import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import styles from './WebhookInfo.module.scss';
import { InfoContainer } from 'components/ui';
import { t } from 'utils';

export interface IWebhookInfo extends HTMLAttributes<HTMLDivElement> {}

const WebhookInfo: FC<IWebhookInfo> = (props) => {
  const { className } = props;
  const rootClassName = classNames(styles.root, className);
  return (
    <InfoContainer className={rootClassName}>
      <h3 className={styles.title}>{t('app.preview.webhooks.emptyInfoLabel')}</h3>
      <p className={styles.text}>{t('app.preview.webhooks.emptyInfoText')}</p>
      <a
        className={styles.link}
        href='https://docs.timify.dev/docs/webhooks'
        target='_blank'
        rel='noreferrer'
      >
        {t('app.preview.webhooks.emptyLinkText')}
      </a>
    </InfoContainer>
  );
};

export default WebhookInfo;
